export default {
  "meta-title": "TARISLAND",
  "meta-description": "《塔瑞斯世界》是一款可以雙端遊玩的經典本格派MMORPG，冒險者們能夠在廣袤無垠的世界中自由開荒，且在多種不同職業中打造專屬於自己的獨門流派，不受遊玩裝置的約束，一起踏上這傳奇般的冒險之旅吧。",
  "meta-keywords": "塔瑞斯世界，塔瑞斯，類wow，mmo，mmorpg，跨平臺，mmorpg手遊，pc mmorpg",
  "meta-name": "《塔瑞斯世界》官方網站",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "《塔瑞斯世界》官方網站",
  "meta-og-title": "《塔瑞斯世界》官方網站",
  "meta-og-description": "您將體驗到一款可雙端遊玩的經典本格派MMORPG，快與您的好友們一起體驗這刺激硬核的開荒之旅吧。",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "《塔瑞斯世界》官方網站",
  "meta-twitter-description": "您將體驗到一款可雙端遊玩的經典本格派MMORPG，快與您的好友們一起體驗這刺激硬核的開荒之旅吧。",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",

  "email_illegal": "不正確的郵箱地址，請檢查並修正。",
  "horizon_tip": "爲取得更好的使用體驗，請豎直使用您的裝置。",


  'downloadPc': "Please download on PC",


  "area": "大區",
  "select-area": "請選擇大區",
  "server": "伺服器",
  "select-server": "請選擇伺服器",
  "character-name": "角色名",
  "select-character": "請選擇角色",
  "please-select": "請選擇",
  "not-found-role": "未查詢到角色",
  'loading': '加載中....',
  'pls_input_info': '請輸入您的登錄信息。',
  "pls_input_email": "請輸入電子郵件地址",
  'FlowHasNotBegin': '活动时间未开始',
  'FlowHasEnd': '活动已结束',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "即刻成為我的塔瑞斯夥伴！\n點擊：",
  "copy_clipboard-text2": "（專屬連結）\n如連結失效，可輸入邀請碼：",
  "friends-completed": " 朋友已完成",
  "no-friends-completed": "沒有朋友完成",
  "pop_invitedlist_s": "已完成",
  "pop_invitedlist_f": "未完成",
  "gift3": "S1成長禮包",
  "gift5": "霜狼之靈（永久）",
  "gift6": "霜狼之靈（1日體驗卡 ）",
  "gift1": "$100 禮品卡",
  "gift2": "$50 禮品卡",
  "gift4": "烈虎之靈（永久）",

  "invite_link_upper_limit": "很抱歉，此邀請連結或邀請碼已達到綁定人數上限",
  "invite_link_disabled": "很抱歉，此邀請連結有誤或邀請碼失效，請與邀請人核對",
  "enter_your_invitation_code": "請輸入您的邀請碼",
  "act_not_start": "活動時間未開始",
  "act_finished": "活動已結束",
  "download_pc": "請在PC上下載",
  "email_error": "不正確的信箱地址，請檢查並修正",
  "loadding": "載入中...",
  "check_my_raffle_history": "查看我的抽獎紀錄",
  "no_raffle_history": "暫無抽獎紀錄",
  "system-error": "系統錯誤",
  "cant-invite-self": "無法使用自己的邀請碼",
};
